var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentmethod2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 64H96C43.072 64 0 107.072 0 160V352C0 404.928 43.072 448 96 448H416C468.928 448 512 404.928 512 352V160C512 107.072 468.928 64 416 64ZM21.3333 170.667H490.667V213.333H21.3333V170.667ZM96 85.3333H416C453.504 85.3333 484.352 113.237 489.579 149.333H22.4213C27.648 113.237 58.496 85.3333 96 85.3333ZM416 426.667H96C54.8267 426.667 21.3333 393.173 21.3333 352V234.667H490.667V352C490.667 393.173 457.173 426.667 416 426.667ZM106.667 298.667C83.136 298.667 64 317.803 64 341.333C64 364.864 83.136 384 106.667 384C130.197 384 149.333 364.864 149.333 341.333C149.333 317.803 130.197 298.667 106.667 298.667ZM106.667 362.667C94.912 362.667 85.3333 353.109 85.3333 341.333C85.3333 329.557 94.912 320 106.667 320C118.421 320 128 329.557 128 341.333C128 353.109 118.421 362.667 106.667 362.667Z",
    fill: "#00A63E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentmethod2);
export default __webpack_public_path__ + "static/media/Payment method 2.a704763c6fd0780172c58b05ae21c6f2.svg";
export { ForwardRef as ReactComponent };